import { computed } from "vue";
import { entityTypes } from "@/src/constants/entityTypeConstants.js";

export function useEntityTypeDetection(slugRef) {
  const getSlug = () => {
    if (typeof slugRef === "function") return slugRef();
    if (slugRef?.value !== undefined) return slugRef.value;
    return slugRef;
  };

  const isTickets = computed(() => getSlug() === entityTypes.TICKETS);
  const isTasks = computed(() => getSlug() === entityTypes.TASKS);
  const isContacts = computed(() => getSlug() === entityTypes.CONTACTS);
  const isLeads = computed(() => getSlug() === entityTypes.LEADS);
  const isCompanies = computed(() => getSlug() === entityTypes.COMPANIES);
  const isDeals = computed(() => getSlug() === entityTypes.DEALS);
  const isProjects = computed(() => getSlug() === entityTypes.PROJECTS);
  const isApprovals = computed(() => getSlug() === entityTypes.APPROVALS);
  const isCRMTasks = computed(() => getSlug() === entityTypes.CRM_TASKS);
  const isStandardEntity = computed(
    () =>
      isContacts.value || isLeads.value || isCompanies.value || isDeals.value,
  );

  const isContactOrLead = computed(() => isContacts.value || isLeads.value);

  return {
    isTickets,
    isTasks,
    isContacts,
    isLeads,
    isCompanies,
    isDeals,
    isProjects,
    isStandardEntity,
    isContactOrLead,
    isApprovals,
    isCRMTasks,
  };
}
